import React, { useContext } from 'react'
import { Box } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'
import ProgressBar from '../../../components/progress-bar/ProgressBar'
import AppContext from '../../context'
import buildStyles from './styles'
import StarIconCD from '../../../shared/icons/star_icon_CD'

const ThanksView = () => {
  const { state } = useContext(AppContext)
  const navigate = useNavigate()

  if (!state.locationDesignConfig) return null

  const styles = buildStyles({
    baseColors: state.locationDesignConfig.baseColors,
  })

  return (
    <>
      {state.selectedGoal && state.selectedOrganization && (
        <>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="column"
            padding="10px"
            className={styles.container}
          >
            <div className={styles.starIcon}>
              <StarIconCD />
            </div>

            <span className={styles.title}>Dziękujemy!</span>

            <span className={styles.bottomText}>
              Dzięki Twojemu wsparciu udało się już zebrać:
            </span>
            <div className={styles.amount}>
              <span className={styles.amount1}>
                {state.amount?.isPaid
                  ? state.selectedGoal.currentAmount / 100 + ' zł '
                  : Number(state.amount?.value) +
                    state.selectedGoal.currentAmount / 100 +
                    ' zł '}
              </span>

              {state.locationDesignConfig &&
                state.locationDesignConfig.isTargetAmount && (
                  <span className={styles.amount2}>
                    / {state.selectedGoal.targetAmount / 100 + ' zł'}
                  </span>
                )}
            </div>

            {state.locationDesignConfig &&
              state.locationDesignConfig.isProgressBar && (
                <ProgressBar
                  completed={
                    ((Number(state.amount?.value) +
                      state.selectedGoal.currentAmount) /
                      state.selectedGoal.targetAmount) *
                    100
                  }
                />
              )}

            <Box
              display="flex"
              width="100%"
              paddingTop="25px"
              justifyContent="center"
            >
              <div
                className={styles.backButton}
                onClick={() =>
                  navigate(`/${state.locationConfig?.locationCode}`)
                }
              >
                <div className={styles.backButtonSpan}>Powrót</div>
              </div>
            </Box>
          </Box>
        </>
      )}
    </>
  )
}

export default ThanksView
